module.exports = __webpack_public_path__ + "images/7ab6cdebe43328994306c63c8ace4103fabe1dee33439a8629f8a25ced641f4a.svg";